export default __webpack_public_path__ + "static/media/bean-1.26eceb3a.png";